import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Sidebar from './Sidebar';
import PageHeader from './components/PageHeader';
import { FaSchool, FaClock, FaRocket } from 'react-icons/fa';
import logo from './logo.png';

export default function InstitutesPage() {
  const { isArabic, sidebarVisible, setSidebarVisible, cachedUserProfile } = useOutletContext() || {};
  const [sidebarOpen] = React.useState(true);
  const isMobile = window.innerWidth <= 600;

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: '#f7f9fb',
      fontFamily: "'IBM Plex Sans Arabic', sans-serif"
    }}>
      <Sidebar
        isOpen={sidebarOpen}
        isVisible={sidebarVisible}
        setSidebarVisible={setSidebarVisible}
        userRole="student"
        isArabic={isArabic}
        cachedUserProfile={cachedUserProfile}
      />
      
      <main style={{
        flex: 1,
        padding: isMobile ? '20px 16px' : '40px 48px',
        paddingLeft: sidebarVisible ? (isMobile ? '16px' : '72px') : (isMobile ? '16px' : '48px'),
        transition: 'padding-left 0.3s',
        width: '100%'
      }}
      dir={isArabic ? 'rtl' : 'ltr'}
      >
        <PageHeader 
          title={isArabic ? 'المعاهد' : 'Institutes'} 
          subtitle={isArabic ? 'قريباً...' : 'Coming Soon...'} 
          isArabic={isArabic} 
        />

        {/* Coming Soon Content */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
          minHeight: '60vh',
            textAlign: 'center',
          padding: isMobile ? '40px 20px' : '80px 40px',
            background: 'linear-gradient(135deg, #fff 0%, #f8fafc 100%)',
          borderRadius: 24,
            boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
          border: '1px solid #e5e7eb',
          marginTop: 24
          }}>
          {/* Logo */}
          <img 
            src={logo} 
            alt="Taealam Logo" 
              style={{
              width: isMobile ? 120 : 160,
              height: isMobile ? 120 : 160,
              objectFit: 'contain',
              marginBottom: 32,
              animation: 'pulse 2s ease-in-out infinite'
            }} 
          />

          {/* Title */}
          <h2 style={{
            fontSize: isMobile ? 28 : 36,
                            fontWeight: 800,
                            color: '#111827',
            marginBottom: 16,
            fontFamily: "'IBM Plex Sans Arabic', sans-serif"
          }}>
            {isArabic ? 'قريباً...' : 'Coming Soon'}
          </h2>

          {/* Description */}
                          <p style={{
            fontSize: isMobile ? 16 : 18,
                            color: '#6b7280',
            maxWidth: 600,
            lineHeight: 1.6,
            marginBottom: 32,
            fontFamily: "'IBM Plex Sans Arabic', sans-serif"
          }}>
            {isArabic 
              ? 'نعمل حالياً على تطوير صفحة المعاهد. سنفتحها قريباً مع ميزات رائعة لمساعدتك في العثور على المعاهد والجلسات المناسبة لك.'
              : 'We\'re currently working on developing the Institutes page. We\'ll open it soon with amazing features to help you find institutes and sessions that suit you.'}
          </p>

          {/* Features Preview */}
                      <div style={{
                        display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
            gap: 20,
            width: '100%',
            maxWidth: 800,
            marginTop: 40
          }}>
            {[
              {
                icon: <FaSchool size={24} color="#ff7a1a" />,
                title: isArabic ? 'استكشف المعاهد' : 'Explore Institutes',
                description: isArabic ? 'تصفح مجموعة واسعة من المعاهد التعليمية' : 'Browse a wide range of educational institutes'
              },
              {
                icon: <FaClock size={24} color="#ff7a1a" />,
                title: isArabic ? 'احجز الجلسات' : 'Book Sessions',
                description: isArabic ? 'احجز الجلسات والدورات بسهولة' : 'Easily book sessions and courses'
              },
              {
                icon: <FaRocket size={24} color="#ff7a1a" />,
                title: isArabic ? 'تجربة محسّنة' : 'Enhanced Experience',
                description: isArabic ? 'واجهة سهلة الاستخدام وميزات متقدمة' : 'User-friendly interface with advanced features'
              }
            ].map((feature, index) => (
              <div
                key={index}
                            style={{
                              background: '#fff',
                  borderRadius: 16,
                  padding: 24,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                  border: '1px solid #e5e7eb',
                              transition: 'all 0.3s',
                              display: 'flex',
                              flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
                            }}
                          >
                              <div style={{
                                    width: 56,
                                    height: 56,
                              borderRadius: 12,
                              background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)',
                              display: 'flex',
                              alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 16
                }}>
                  {feature.icon}
                          </div>
                <h3 style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: '#111827',
                  marginBottom: 8,
                  fontFamily: "'IBM Plex Sans Arabic', sans-serif"
                }}>
                  {feature.title}
                </h3>
                <p style={{
                            fontSize: 14,
                  color: '#6b7280',
                  lineHeight: 1.5,
                              margin: 0,
                  fontFamily: "'IBM Plex Sans Arabic', sans-serif"
                }}>
                  {feature.description}
                </p>
                    </div>
                  ))}
                </div>
                </div>

        <style>{`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.05);
              opacity: 0.9;
            }
          }
        `}</style>
      </main>
    </div>
  );
}
